{
  "labels": {
    "ime": "Nome:",
    "priimek": "Cognome:",
    "naslov": "Indirizzo:",
    "posta": "CAP:",
    "kraj": "Città:",
    "email": "E-mail:",
    "telefon": "Telefono:",
    "klub": "Seleziona club:",
    "naletJ": "Ore aliante:",
    "naletM": "Ore motore:",
    "licenca": "Numero di licenza",
    "instruktor": "Istruttore (motore)",
    "instruktorJ":"Istruttore (aliante)",
    "instruktorUL": "Istruttore (ultralight)",
    "vlecniR": "Rating traino",
    "opomba": "Nota",
    "jadralniP": "Pilota (aliante)",
    "motorniP": "Pilota (motore)",
    "ultraP": "Pilota (ultralight)"
  },
  "buttons": {
    "vnos": "Aggiungi voce",
    "brisiIzbiro": "Cancella selezione"
  }
}